@if (displayInteractiveVariant()) {
<app-icon [size]="2.5" icon="mountain" />
<span class="value">
  <span>{{ value() }}</span>
  <span class="unit">%</span>
</span>
} @else {
<app-icon [size]="2.5" icon="force" />
<span class="value">{{ value() }}</span>
<span class="levels">
  @for (level of [].constructor(10); track $index) {
  <div [class.inactive]="resistanceLevel() < $index" [class]="'level-' + $index" class="level"></div>
  }
</span>
}